import { render, staticRenderFns } from "./CheckoutSuccess.vue?vue&type=template&id=47715764"
import script from "./CheckoutSuccess.vue?vue&type=script&lang=ts"
export * from "./CheckoutSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports